import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { InicioService } from '../../services/inicio.service';
import { RolesService } from '../../services/roles.service';
import { CommonModule } from '@angular/common';
import { RolesFormComponent } from "./roles-form/roles-form.component";
import { ModalComponent } from '../modal/modal.component';

@Component({
  selector: 'app-listar-roles',
  standalone: true,
  imports: [CommonModule, RolesFormComponent, ModalComponent],
  templateUrl: './listar-roles.component.html',
  styleUrl: './listar-roles.component.css'
})
export class ListarRolesComponent implements OnInit{
  @ViewChild(ModalComponent) mdl!: ModalComponent;
  editableRole: any;
  isRolesForm: boolean = false;
  isEdit: boolean = false;
  rolesList : any[] = [];
  errorMessage: string = ''
  srvLogin =  inject(InicioService);
  rol =  inject(RolesService);
  user: any;
  canActivate: boolean = false;
  canEdit: boolean = false;
  canCreate: boolean = false;
  status: boolean = false;
  nombre_rol!: string;


  titulo!: string;
  tipo_color!: string;
  letra_color!: string;
  mensaje!: string;


  ngOnInit(): void {
    this.srvLogin.user$.subscribe(user => {
      this.user = user;
      /*
      this.user.forEach((rs:any) =>{
        if(rs.id_menu == 34) this.canActivate = true;
        if(rs.id_menu == 35) this.canCreate = true;
        if(rs.id_menu == 36) this.canEdit = true;
      })
      */
    });
  }


  ngAfterViewInit(): void {
    this.listar(true);
  }

  listar(v:boolean){
    if(v)this.mdl.cargando();
    this.rol.listarRples().subscribe({
      next: (rs) => {
        if(v)this.mdl.cerrar();
        this.rolesList = rs.data;
        //console.log("Datos recibidos:", this.resultado);
      },
      error: (error) => {
        this.errorMessage = error.message; // Muestra el mensaje de error al usuario
        //console.error("Error en el componente:", error); // Registro del error en el componente
      }
    });
  }

  newRole(){
    this.isEdit = false;
    this.nombre_rol = 'Agregar un Nuevo Rol'
    this.editableRole = [];
    this.isRolesForm = true;
  }

  editRole(rol: any, nombre: string, status: boolean){
    this.editableRole = rol;
    this.nombre_rol = nombre;
    this.status = status;
    this.isEdit = true;
    this.isRolesForm = true;
  }

  hideForm(obj: any) {
    if(!obj.validador){
      this.titulo = '!EXITO¡';
      this.tipo_color = 'success';
      this.letra_color = 'light';
      this.mensaje = 'Petición realizada.';
      this.mdl.alerta();
    }
    this.editableRole = [];
    this.isRolesForm = obj.value;
    this.listar(false)
  }

}
